
angular.module('directives')
    .directive('fancyCheckbox', () => ({
        template: require('../../../views/directives/controls/fancy-checkbox.html'),
        restrict: 'EA',
        replace: true,
        scope: {
            twoStepValidationCheckbox: '=ngModel',
            changeCallback: '&ngChange',
        },
        link: (scope, elem) => {

            elem.bind('click', () => {

                scope.$apply(() => {

                    scope.twoStepValidationCheckbox = !scope.twoStepValidationCheckbox;
                    scope.changeCallback()(scope.twoStepValidationCheckbox);

                });

            });

        },
    }));



// WEBPACK FOOTER //
// ./scripts/directives/controls/fancy-checkbox.js